//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { PropertyType } from './PropertyType';
  
  export class PropertyModel extends ModelBase {
      static readonly $typeName = 'PropertyModel';
      public name: string;
      public propertyType: PropertyType;
      public value: string;
      public key: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/PropertyModel.ts